var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('ProposalInfos',{attrs:{"proposal":_vm.proposal,"initial-tab":_vm.initialTab},on:{"update":_vm.reload}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }